import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-simple-loader",
  templateUrl: "./simple-loader.component.html",
  styleUrls: ["./simple-loader.component.scss"],
  standalone: true,
  imports: [CommonModule],
})
export class SimpleLoaderComponent {}
